import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from '../../../model';
import styles from './style.css';

const setDialogClass = (isPreview, dialogIsMax, isDialogDraging, styles) => {
    if (isPreview) {
        return styles.dialogPreview;
    } else if (dialogIsMax) {
        return styles.max;
    } else if (isDialogDraging) {
        return styles.dialog;
    } else {
        return styles.normalDialog;
    }
};

class Dialog extends React.PureComponent {
    static propTypes = {
        dialogData: PropTypes.object,
        uiStateUpdate: PropTypes.func,
        uiState: PropTypes.object,
        dialogPosition: PropTypes.object,
        dialogPositionUpdate: PropTypes.func,
    };

    time = Date.now();

    getPath = () => {
        const { id, type } = this.props.dialogData;

        const isBiz = typeof window === 'undefined' ? false : window.location.href.includes('biz=true');

        /* eslint-disable no-undef */
        if (isBiz) {
            return `${ChipUrl.replace('ucms', 'bizucms')}/${type}/edit/${id}?_=${this.time}`;
        } else {
            return `${ChipUrl}/${type}/edit/${id}?_=${this.time}`;
        }
        /* eslint-enable no-undef */
    };
    maxFn = () => {
        this.props.uiStateUpdate({
            dialogIsMax: true,
        });
    };
    normalFn = () => {
        this.props.uiStateUpdate({
            dialogIsMax: false,
        });
    };
    close = () => {
        this.props.uiStateUpdate({
            dialogIsMax: false,
            dialogIsShow: false,
        });
        this.time = Date.now();
    };
    exitPreview = () => {
        if (this.props.uiState.isPreview) {
            this.props.uiStateUpdate({ isPreview: false });
        }
    };

    handleTitleMousedown = e => {
        const { isPreview, dialogIsMax } = this.props.uiState;

        if (isPreview || dialogIsMax) {
            return;
        }

        const { x, y } = this.props.dialogPosition;
        const initPosition = { x: e.pageX - x, y: e.pageY - y };
        const move = e => {
            this.props.dialogPositionUpdate({
                x: e.pageX - initPosition.x,
                y: e.pageY - initPosition.y,
            });
        };

        this.props.uiStateUpdate({
            isDialogDraging: true,
        });
        const up = () => {
            document.body.removeEventListener('mousemove', move);
            document.body.removeEventListener('mouseup', up);
            this.props.uiStateUpdate({
                isDialogDraging: false,
            });
        };

        document.body.addEventListener('mousemove', move);

        document.body.addEventListener('mouseup', up);

        // 防止鼠标滑出浏览器
        document.body.addEventListener('mouseleave', up);
    };
    render() {
        const { title, type } = this.props.dialogData;
        const { x, y } = this.props.dialogPosition;
        const { dialogIsShow, dialogIsMax, isPreviewAll, isPreview, isDialogDraging } = this.props.uiState;

        return dialogIsShow
            ? ReactDOM.createPortal(
                  <f-div class={isPreviewAll ? styles.maskHide : styles.mask}>
                      <f-div
                          class={setDialogClass(isPreview, dialogIsMax, isDialogDraging, styles)}
                          style={{ transform: `translate(${dialogIsMax ? 0 : x}px, ${dialogIsMax ? 0 : y}px)` }}>
                          <f-div class={isPreview ? styles.headerPreview : styles.header} onClick={this.exitPreview}>
                              <f-div class={styles.title} onMouseDown={this.handleTitleMousedown}>
                                  {title}({type})
                                  {isPreview ? '预览中，点击标题栏恢复编辑状态' : ''}
                              </f-div>
                              <f-div class={styles.tools}>
                                  <f-span class={styles.maxHandle} onClick={this.maxFn} title="最大化" />
                                  <f-span class={styles.normalHandle} onClick={this.normalFn} title="恢复" />
                                  <f-span class={styles.close} onClick={this.close} title="关闭" />
                              </f-div>
                          </f-div>
                          <f-div class={isPreview ? styles.bodyPreview : styles.body}>
                              {isDialogDraging ? <f-div class={styles.iframeMask} /> : null}
                              <iframe src={this.getPath()} className={styles.iframe} />
                          </f-div>
                          <div />
                      </f-div>
                  </f-div>,
                  document.body,
              )
            : null;
    }
}

const mapStateToProps = state => ({
    dialogData: state.dialogData,
    uiState: state.uiState,
    dialogPosition: state.dialogPosition,
});

const mapDispatchToProps = dispatch => ({
    uiStateUpdate: data => dispatch(actions.uiStateUpdate(data)),
    dialogPositionUpdate: data => dispatch(actions.dialogPositionUpdate(data)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Dialog);
